var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('b-container',[_c('b-jumbotron',{attrs:{"header":"404 Not Found","lead":"This page could not be found."}},[_c('b-button',{attrs:{"to":"/","variant":"primary"}},[_vm._v("Go Home")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }